import React from 'react';

type AffiliateBenefitsItemProps = {
  icon: React.ReactNode;
  title: string;
  description: string;
};

function AffiliateBenefitsItem({
  icon,
  title,
  description,
}: AffiliateBenefitsItemProps) {
  return (
    <div className="flex flex-col items-center justify-center space-y-3 text-center md:space-y-5">
      {icon}
      <div className="md:text-mlg text-sm font-bold text-primary-dark">
        {title}
      </div>
      <div className="md:text-sxs max-w-sm text-primary-pale md:max-w-md">
        {description}
      </div>
    </div>
  );
}

export default AffiliateBenefitsItem;
